import * as R from 'ramda'

export function dbotBlockApi(block) {
    if (!block) return null;
    let allNodes = getAllNodes(block);
    return {
        processNode(id) {
            return processNode(id, [], allNodes, block.blockName);
        },

        initConversation() {
            if (block.initId === -99) return [];
            return this.processNode(block.initId);
        },

        blockName : block.blockName,

        getNode(id) {
            return R.find(node => node.id === id, allNodes)
        },

        allNodes,

        block,

        gifs : block.gifs,

        length: allNodes.filter(node => node.type === "button-box").length
    }
}

export const toConversationRecord = (block, node, dateTime, textInput) => {
    return !!textInput ?  {block, id : node.id, dateTime, textInput} : {block, id : node.id, dateTime};
};

function processNode(id, buffer , conversationNodes , block)  {
    let node = R.find(node => node.id === id, conversationNodes);
    if (node == null) {
        throw Error(`Dbot node with id '${id}' not found`);
    }
    switch (node.type) {
        case "end-box":
            return [...buffer, toConversationRecord(block, node, new Date())];
        case "quick-box":
            return processNode(node.pointer, [...buffer, toConversationRecord(block, node, new Date())], conversationNodes, block);
        case "button-box":
            return [...buffer, toConversationRecord(block, node, new Date())];
        case "button":
            throw new Error(`A button cannot be resolved. Use pointer directly. Id: '${id}' Block: '${block}'`);
        default:
            throw new Error(`Cannot resolve node with id '${id}' with type '${node.type}'`);
    }
}


export function getAllNodes(block) {
    return R.flatten(
        R.map(flattenNodeAndButtons, block.nodes)
    )
}

function flattenNodeAndButtons(node) {
    if (node.buttons != null) return [...node.buttons, node] ;
    else return node
}




